<template>
  <div
    class="accordion-item"
    :class="{ 'open-accordion': isOpen }"
    @click="toggle"
    @keydown="handleKeyPress"
    tabindex="0"
  >
    <h2 class="accordion-title">
      <div>
        <span>{{ formattedIndex }}.</span>
        {{ accordion.Title }}
      </div>
      <span>
        <span class="plus-icon" v-if="!isOpen"><plus-icon /></span>
        <span class="minus-icon" v-if="isOpen"><minus-icon /></span>
      </span>
    </h2>
    <Markdown
      class="content accordion-content"
      :source="accordion.Content"
      html
      breaks
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue';

import MinusIcon from "./svg/MinusIcon.vue";
import PlusIcon from "./svg/PlusIcon.vue";
import Markdown from 'vue3-markdown-it';

export default defineComponent({
  components: {
    MinusIcon,
    PlusIcon,
    Markdown,
  },
  props: {
    accordion: {
      type: Object as PropType<{ Title: string; Content: string }>,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    function toggle() {
      emit('toggle', props.index);
    }

    function handleKeyPress(event: KeyboardEvent) {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        toggle();
      }
    }

    const formattedIndex = computed(() => {
      return (props.index + 1).toString().padStart(2, '0');
    });

    return {
      accordion: props.accordion,
      toggle,
      formattedIndex,
      handleKeyPress,
    };
  },
});
</script>
